import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import client from '~/clients/api-client'
import { useStore } from '~/store/store'

import { MultiQueryOptions } from '../../entities/useMultiQuery'
import { handleApiRequest } from '../../shared/apiWrapper'
import { useSentryLogging } from '../../shared/useSentryLogging'

/**
 * Fetch surgery bookmarks and put them in the store.
 *
 * @param options - (Optional) Parameters for the queries, such as skip and refetchInterval.
 */
export const useGetSurgeryBookmarksQuery = (options?: MultiQueryOptions) => {
    const setBookmarks = useStore(state => state.surgeryBookmarks.actions.setBookmarks)

    const query = useQuery({
        queryKey: ['surgeryBookmarks'],
        queryFn: async () => handleApiRequest({ apiCall: () => client.surgeryBookmarks.get() }),
        enabled: !options?.skip,
    })

    useEffect(() => {
        if (query.data) {
            setBookmarks(query.data.map(surgeryBookmark => surgeryBookmark.folder_id))
        }
    }, [query.data, setBookmarks])

    useSentryLogging({
        key: 'useSurgeryBookmarksQuery',
        queryResult: query,
        toastNotification: { showToast: true, toastMessage: 'Klarte ikke å hente dine pasientbokmerker.' },
    })

    return query
}
